var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_2329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0507812,
    width: 40,
    height: 40,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_2329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.015 21.7639L26.9288 28.6777C27.1593 28.9003 27.468 29.0235 27.7885 29.0207C28.1089 29.0179 28.4154 28.8894 28.642 28.6628C28.8686 28.4362 28.9972 28.1297 29 27.8092C29.0027 27.4888 28.8796 27.18 28.6569 26.9495L21.7432 20.0358L28.6569 13.122C28.8796 12.8915 29.0027 12.5828 29 12.2623C28.9972 11.9419 28.8686 11.6353 28.642 11.4087C28.4154 11.1821 28.1089 11.0536 27.7885 11.0508C27.468 11.048 27.1593 11.1712 26.9288 11.3939L20.015 18.3076L13.1012 11.3939C12.8697 11.1767 12.5628 11.0582 12.2454 11.0634C11.928 11.0685 11.6251 11.1969 11.4007 11.4215C11.1764 11.646 11.0482 11.949 11.0432 12.2664C11.0383 12.5838 11.157 12.8906 11.3743 13.122L18.2869 20.0358L11.3731 26.9495C11.2564 27.0623 11.1633 27.1971 11.0992 27.3462C11.0352 27.4954 11.0015 27.6557 11 27.818C10.9986 27.9803 11.0296 28.1412 11.091 28.2914C11.1525 28.4416 11.2432 28.5781 11.358 28.6928C11.4727 28.8076 11.6092 28.8983 11.7594 28.9598C11.9096 29.0212 12.0705 29.0521 12.2328 29.0507C12.3951 29.0493 12.5554 29.0156 12.7045 28.9516C12.8536 28.8875 12.9885 28.7944 13.1012 28.6777L20.015 21.7639Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBlack);
export default __webpack_public_path__ + "static/media/icon_close_black.52e52dd195dc1741d96ffc5b5a4ab9b9.svg";
export { ForwardRef as ReactComponent };